import type { AxiosRequestConfig } from 'axios';
import axios from '../lib/axios';

export async function fetchWithToken(
  path: string,
  token: string,
  options?: AxiosRequestConfig,
) {
  const res = await axios.request({
    ...options,
    url: path,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
}
